import React from "react";

/**
 * BETA MODE — closed beta (6-12 months).
 *
 * The full subscription/upsell banner is disabled during the beta because
 * every authenticated user has full Premium access for free. The component
 * stays as a no-op export so AppShell continues to mount it without changes.
 * Restore from git history when the paid launch happens.
 */
const SubscriptionBanner = () => null;

export default SubscriptionBanner;
